
import { defineComponent, onMounted, ref } from 'vue'
import { useStore } from '@/store/index'
import { useRoute } from 'vue-router'
import { axios, ApiResponse } from '@/plugins/axios'
import LayoutsAuth from '@/layouts/Auth.vue'
import { NoticeAttributes } from '@/types/models/notice'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'

export default defineComponent({
  components: { LayoutsAuth, LayoutsAuthWidth },
  setup() {
    const store = useStore()
    const route = useRoute()
    const notice = ref<NoticeAttributes | undefined>()

    onMounted(() => {
      axios
        .get<ApiResponse<NoticeAttributes>>(`/notice/${route.params.notice_id}`)
        .then(response => {
          notice.value = response.data.payload
        })
    })

    return {
      store,
      notice
    }
  },
})
